// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file anu/cat_app/sas.proto (package anu.cat_app, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_patch_go } from "../../patch/go_pb";

/**
 * Describes the file anu/cat_app/sas.proto.
 */
export const file_anu_cat_app_sas = /*@__PURE__*/
  fileDesc("ChVhbnUvY2F0X2FwcC9zYXMucHJvdG8SC2FudS5jYXRfYXBwImIKC0FjYWRlbWljT3JnEhAKCG9yZ19jb2RlGAEgASgJEhcKD29yZ19kZXNjcmlwdGlvbhgCIAEoCRISCgppc19jb2xsZWdlGAMgASgIEhQKDGNvbGxlZ2VfY29kZRgEIAEoCSKwAQoMQWNhZGVtaWNUZXJtEhEKCXRlcm1fY29kZRgBIAEoCRIVCg1hY2FkZW1pY195ZWFyGAIgASgDEhgKEHRlcm1fZGVzY3JpcHRpb24YAyABKAkSLgoKc3RhcnRfZGF0ZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX2RhdGUYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIhgKFkdldEFjYWRlbWljT3Jnc1JlcXVlc3QiQQoXR2V0QWNhZGVtaWNPcmdzUmVzcG9uc2USJgoEb3JncxgBIAMoCzIYLmFudS5jYXRfYXBwLkFjYWRlbWljT3JnQjNaK2dpdGh1Yi5jb20vYW51LWl0cy9jYXQtZ3JwYy1hcHAtcGI7Y2F0YXBwcGLKtQMCCAFiBnByb3RvMw", [file_google_protobuf_timestamp, file_patch_go]);

/**
 * Describes the message anu.cat_app.AcademicOrg.
 * Use `create(AcademicOrgSchema)` to create a new message.
 */
export const AcademicOrgSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_sas, 0);

/**
 * Describes the message anu.cat_app.AcademicTerm.
 * Use `create(AcademicTermSchema)` to create a new message.
 */
export const AcademicTermSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_sas, 1);

/**
 * Describes the message anu.cat_app.GetAcademicOrgsRequest.
 * Use `create(GetAcademicOrgsRequestSchema)` to create a new message.
 */
export const GetAcademicOrgsRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_sas, 2);

/**
 * Describes the message anu.cat_app.GetAcademicOrgsResponse.
 * Use `create(GetAcademicOrgsResponseSchema)` to create a new message.
 */
export const GetAcademicOrgsResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_sas, 3);

